import { Icon } from "./Icons";

export function DarkToggle({ dark, setDark }) {
  return (
    <label className="dm-label" title="Toggle theme">
      <Icon name={dark ? "sun" : "moon"} size={15} />
      <button
        className={`dm-toggle ${dark ? "on" : ""}`}
        onClick={() => setDark(d => !d)}
        aria-label="Toggle dark mode"
      />
    </label>
  );
}
